export default {
  parseRecordData: function (data) {
    return {
      recordId: data.record_id,
      eventId: data.event_id,
      format: data.format, // 'jpg', 'mp4'
      mediaTimestamp: data.timestamp,
      // CHEKT-1406: 목록 응답에서 url이 제거될 수 있다(mp4는 항상 없음, jpg는 store에서 snapshots URL 주입).
      // url이 없을 때 data.url.indexOf 호출로 크래시하지 않도록 방어한다.
      mediaUrl: data.url,
      hasAccessToken: data.url ? data.url.indexOf('?') > -1 : false,
      deviceInfo: {
        deviceId: data.device_id,
        isPrivacyEnabled: !!data.is_privacy
      },
      statusInfo: {
        createdDate: data.created ? new Date(data.created) : null,
        completed: !!data.completed,
        downloaded: false,
        reallyUploaded: null, // it is to validate 'data.completed'
        codec: null,
        completedClassification: !!data.completed_classification,
        completedCaptioning: !!data.completed_captioning
      }
    }
  },
}
